export class SenderEmailViewModel {
  constructor(
    public email: string,
    public serverSmtp: string,
    public password: string,
    public port: number,
    public enableSsl: boolean
  ) {}
}
